import { TimeRange } from '@web/app/components/TimeRangeControls';
import { subDays, subMonths, subYears } from 'date-fns';

export const getTimeRangeCutoff = (timeRange: TimeRange) => {
  const now = new Date();
  return {
    '1W': subDays(now, 7),
    '1M': subMonths(now, 1),
    '3M': subMonths(now, 3),
    '6M': subMonths(now, 6),
    '1Y': subYears(now, 1),
    ALL: new Date(0),
  }[timeRange];
};

export const filterByTimeRange = <
  T extends { created_at: string; base_price: number }
>(
  data: T[],
  timeRange: TimeRange
) => {
  const cutoffDate = getTimeRangeCutoff(timeRange);
  return data.filter((item) => new Date(item.created_at) >= cutoffDate);
};
